// DAT-25: SBA Small Business Search (SBS, which replaced DSBS and reads SAM)
// is a link-out only — never scraped. Twin of publicsource.SBSProfileURL (Go).
export const SBS_HOME_URL = 'https://search.certifications.sba.gov/';
const UEI_RE = /^[A-Z0-9]{12}$/;
const CAGE_RE = /^[A-Z0-9]{5}$/;
/**
 * SBS profile deep link when both a valid UEI and CAGE are known (SBS's route
 * is /profile/:uei/:cage_code; it has no UEI-only deep link); else SBS home.
 */ export function SBSProfileURL(uei, cage) {
    const u = (uei ?? '').trim().toUpperCase();
    const c = (cage ?? '').trim().toUpperCase();
    if (UEI_RE.test(u) && CAGE_RE.test(c)) {
        return `${SBS_HOME_URL}profile/${u}/${c}`;
    }
    return SBS_HOME_URL;
}
